import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { DevicesRepository } from 'common/repositories/index';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$state'];

class DeviceSettingsController {

    constructor($scope, $state) {

        this.$scope = $scope;
        this.$state = $state;
        this.device = DevicesRepository.getById($scope.deviceId);
        this.isMobileDevice = DevicesRepository.isMobile($scope.deviceId);
        this.isLockFunctionalityAvailable = this.checkLockAvailability();

    }

    onSettingsItemClick(itemName) {

        const currentPage = this.$state.current.name;
        let currentPageMixpanel;

        if (currentPage === 'root.dashboard.devices') {

            currentPageMixpanel = 'My Devices';

            if (itemName === 'Lock') {

                this.$state.go('root.dashboard.devices.ltb', {
                    ltb: 'lock-device',
                    resourceId: this.device.id,
                });

            } else if (itemName === 'Unlock') {

                this.$state.go('root.dashboard.devices.ltb', {
                    ltb: 'unlock-device',
                    resourceId: this.device.id,
                });

            } else if (itemName === 'Remove') {

                this.$state.go('root.dashboard.devices.ltb', {
                    ltb: 'remove-device',
                    resourceId: this.device.id,
                });

            }

        } else if (currentPage === 'root.dashboard.device-details') {

            currentPageMixpanel = 'Device Details';

            if (itemName === 'Lock') {

                this.$state.go('root.dashboard.device-details.ltb', {
                    ltb: 'lock-device',
                    resourceId: this.device.id,
                });

            } else if (itemName === 'Unlock') {

                this.$state.go('root.dashboard.device-details.ltb', {
                    ltb: 'unlock-device',
                    resourceId: this.device.id,
                });

            } else if (itemName === 'Remove') {

                this.$state.go('root.dashboard.device-details.ltb', {
                    ltb: 'remove-device',
                    resourceId: this.device.id,
                });

            }

        }

        Mixpanel.send(`ConnectWeb Device Settings ${itemName} Click`, {
            Page: currentPageMixpanel,
        });

    }

    /*  lock/unlock functionality is available only for PC's/Laptops
        with Windows operating system */
    checkLockAvailability() {

        return !this.isMobileDevice && this.device &&
            this.device.attributes.os === 'windows';

    }

}

class DeviceSettingsDirective {

    constructor() {

        this.template = require('./device-settings.html');
        this.restrict = 'E';
        this.replace = true;
        this.scope = { deviceId: '=', isLocked: '=' };

        _controllerDependencies.push(($scope, $state) =>
            new DeviceSettingsController($scope, $state));
        this.controller = _controllerDependencies;
        this.controllerAs = 'deviceSettingsCtrl';

    }

}

_directiveDependencies.push(() => new DeviceSettingsDirective());


angular.module('directives')
    .directive('deviceSettings', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/device-settings/device-settings.js